import React, { useState, useEffect } from "react";
import axios from "axios";

import { useForm, Controller, control, NavLink } from "react-hook-form";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';

import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header.jsx";
//import sendDataToAPI from '../../methods/sendDataToAPIs.jsx';

import { DatePicker, Space } from 'antd';
import Contacts from "../../scenes/contacts/index.jsx";
//import itemNavLink from "./ItemNavLink.jsx";
import TableCMAA from "../form/TableCMAA.jsx";
import TableXDataGrid from "../form/TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";
import { API_URL, URL as MYURL } from "./constants";

const TXTRoundedDiv = styled("div")(({ theme }) => ({
  backgroundColor: "",
  border: '1px solid #6BD5C0',
  //borderColor: "#6BD5C0",
  /** 
   * #6BD5C0
   * #8868B0
   *#320B63
   #01579b
   #4527a0
   #311b92
  **/
  borderRadius: theme.shape.borderRadius,
  width: "100%",
  fontSize: "14px",
  marginBottom: "10px"
}));

{/**
const TXTRoundedDiv = styled("div")(({ theme }) => ({
  backgroundColor: "grey",
  borderRadius: theme.shape.borderRadius,
  width: "100%",
  fontSize: "14px",
  marginBottom: "10px"
}));
**/}

const StyledBox= styled(Box)({
  marginLeft: "10px",
  marginRight: "10px",
  marginTop: "10px",
})


const StyledInput= styled(Input)({
  width: "100%",
  fontSize: "14px",
  //fontColor: "black",
  height: "95%",
  marginBottom: "2px",
  marginTop: "2px",
})

{/**
**/}

const StyledSelect= styled(Select)({
  width: "100%",
  fontSize: "14px",
  fontColor: "white",
  height: "95%",
  marginBottom: "2px",
  marginTop: "2px",
})

export default function FRMAXIOSEDIT({props}) {
  const [ProjectCategoryID, setProjectCategoryID]=useState(props.ProjectCategoryEditID);
  console.log("ProjectCategoryID===" + ProjectCategoryID);
  const [ProjectCategoryName, setProjectCategoryName] = useState('');
  const [PicIntro, setPicIntro] = useState("");
  const [WebIntro, setWebIntro] = useState("");
  const [image, setImage] = useState(null);
  const [posts, setPosts] = useState([]);
  const [call, setCall] = useState(true);
  const [PicFile, setPicFile]=useState();
  const [ServiceCategory, setServiceCategory]=useState({})
  
  useEffect(() => {
    axios.get(API_URL).then((result) => setPosts(result.data));
    console.log("Hi there");
    console.log(posts.length);
  }, [call]);

  const handleProjectCategoryName = (e) => {
    
    console.log("e.target.value=" + e.target.value)
    setProjectCategoryName(e.target.value);
    console.log("ProjectCategoryName=" + ProjectCategoryName)
    e.preventDefault();
  };
  
  const [Test, setTest]=useState('');
  
  const handleTest = (e) => {
    
    console.log("e.target.value=" + e.target.value)
    setTest(e.target.value);
    console.log("test=" + Test)
    e.preventDefault();
  };

  const handlePicIntro = (e) => {
    e.preventDefault();
    setPicIntro(e.target.value);
  };

  const handleWebIntro = (e) => {
    e.preventDefault();
    setWebIntro(e.target.value);
  };

  const handleImage = (e) => {
    e.preventDefault();
    console.log(e.target.files);
    setImage(e.target.files[0]);
    setPicFile(URL.createObjectURL(e.target.files[0]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(ProjectCategoryName, PicIntro, image);

    let form_data = new FormData();
    form_data.append("img", image, image.name);
    //form_data.append("ProjectCategoryName", ProjectCategoryName);
    //form_data.append("PicIntro", PicIntro);
    
    let url = API_URL;
    let picsId=0;
    axios
      .post(url, form_data, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data=" + res.data);
        console.log("res.data['id']=" + res.data['id']);
        picsId=res.data['id'];

      })
      .finally(() => {
        //setLoading(true);
        setImage(null);
        //setContent("");
        if(picsId>0){
         postImageProjectDetails(picsId);
         }
    
      })
      .catch((err) => console.log(err));

    //setTitle("");
    
  };

  const postImageProjectDetails = (picsId)=>{
    let xURL='/myapi/postPrimaryProjectCategory';
    console.log("ServiceCategory['id']=" + ServiceCategory['id']);
    
    let bodyData={
     'service_category': ServiceCategory['id'],
     'name': ProjectCategoryName,
     'pic_intro': PicIntro,
     'intro_txt': WebIntro,
     'status': picsId
    };
    //return;
    let headerOptions={
     method: 'POST',
     headers: {'Content-Type': 'application/json'},
     body: JSON.stringify(bodyData)
    };

    fetch(xURL, headerOptions)
    .then( response=> response.json())
    .then ( json => console.log(json))


  }
    //PTXTRoundedDiv=TXTRoundedDiv
    //PStyledBox=StyledBox
    //
    const[tableColumns, setTableColums]=useState(
      [
        {'id': 1, 'ProjectCategoryName': 'ID', 'name': 'id'},
        {'id': 2, 'ProjectCategoryName': 'First Name', 'name': 'first_name'},
        {'id': 3, 'ProjectCategoryName': 'Middle Name', 'name': 'middle_name'},
        {'id': 4, 'ProjectCategoryName': 'Last Name', 'name': 'last_name'},
        {'id': 5, 'ProjectCategoryName': 'Telephone', 'name': 'telephone'},
        {'id': 6, 'ProjectCategoryName': 'Email', 'name': 'email'},
        {'id': 7, 'ProjectCategoryName': 'Gender', 'name': 'gender'},
    ]
    )
    //
   
    const colourStyles = {
      
    }
    
    //
    //
   
    //
     const tableXDataGridColumns =[
        {
          field: 'id',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left'
      },
      {
        field: 'first_name',
        headerName: 'First Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'middle_name',
      headerName: 'Middle Name',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  {
  field: 'telephone',
  headerName: 'Telephone',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
    {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
    },

    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
      },
     ]
    //
    
    //
    const [firstName, setFirstName] = useState('');
    
    const [formData, setFormData]=useState([
      {'name': 'txtFirstName', 'value': firstName, 'type': 'string'}
    ]);
     
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    

    /***
    ***/
    /** **/
    
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Form')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Records')
       }
    }
    const [showForm, setShowForm] = useState(true);
    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    
    function changeFirstName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setFirstName(e ? e: "");
    }

    
      
      const [fName, setFName]=useState("f name");
      //const [MiddleName, setMiddleName]=useState(props?.value ?? '');
      const [MiddleName, setMiddleName]=useState('');
      
      const changeMiddleName = (e) =>{
        // setFirstName(e);
        e.preventDefault();
        console.log("eeh=" + e.target.value);
        setMiddleName(e.target.value ? e.target.value: "");
      }

      const [ServiceCategoryList, setServiceCategoryList ]=useState([{}]);
      
      const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...base,
          backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
      }
    };
    
    function loadServiceCategory(data){
      console.log("data=" + data);
      let newData=[];
      newData.push({ 'value': 'Select Service Category', 'label': 'Select Service Category', 'id': 0});
      
      
      data.map(function(data){
        newData.push({ 'value': data.name, 'label': data.name, 'id': data.id});
        console.log("data.name=" + data.name);
      })
      
      setServiceCategoryList(newData);
    }
    
    let getProjectCategoryURL="/myapi/ServiceCategoryListView"
    useEffect(()=>{
     
      fetch(getProjectCategoryURL)
      .then( response=> response.json())
      .then( json => loadServiceCategory(json))

    }, [])
  
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
     
      
      <br/>
      
      
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={4}>
            
            <TXTRoundedDiv>
              <Select
                  
                  options={ServiceCategoryList}
                  
                  styles={customStyles}
                  onChange={(event)=>{
                    console.log("AUDIT=" + event.value);
                    setServiceCategory({value: event.value, label:event.value, id:event.id});
                  }}
                  value={ServiceCategory}
              />
            </TXTRoundedDiv>
        
           <TXTRoundedDiv>
           <StyledInput
            type="text"
            placeholder="Project Category Name"
            id="ProjectCategoryName"
            value={ProjectCategoryName}
            onChange={handleProjectCategoryName}
            
            required
          />
           </TXTRoundedDiv>
           
            <TXTRoundedDiv>
            <StyledInput
            type="text"
            placeholder="Pic Intro"
            id="PicIntro"
            value={PicIntro}
            onChange={handlePicIntro}
            required />
            </TXTRoundedDiv>
            
            <TXTRoundedDiv>
            <StyledInput
            type="text"
            placeholder="Web Intro"
            id="WebIntro"
            value={WebIntro}
            onChange={handleWebIntro}
            required />
            </TXTRoundedDiv>

            <TXTRoundedDiv>
            <StyledInput
            type="file"
            id="image"
            accept="image/png,image/jpeg"
            onChange={handleImage}
            required
            />
            </TXTRoundedDiv>
            <img src={PicFile}  width={350} height={200} />
           
           <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>

           </TXTRoundedDiv>
           
           {/** **/}
             
           
           
          </StyledBox>
          
          <StyledBox flex={4}>    
         

           
           <br>
           
           {/** onChangeDOB */}
           
           {/** <AntdDatePicker getDateFromADP={getDateFromADP} /> **/}

           {/** <Axntd /> **/}
           
          
           </br>
         
        
          </StyledBox>
          
          <StyledBox flex={4}>

          </StyledBox>

        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">
        <Box display="flex" justifyContent="end" mt="20px">
              
              {/******/}
              
              <Button type="submit" color="secondary" variant="contained" onClick={handleSubmit}>
                Edit Project Category
              </Button>
        </Box>

        </Stack>
        
      </Box>
      
    )
  }